import { render, staticRenderFns } from "./event-management-register-main.vue?vue&type=template&id=435e156a&"
import script from "./event-management-register-main.vue?vue&type=script&lang=js&"
export * from "./event-management-register-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports